<template>
  <div class="main pb-x8">
    <PageLoader :isActive="isLoading || isLoadingZoho"/>
    <Nav :authRequired = "true"/>
    <div class="container">
      <div class="row mb-x4">
        <!-- <div class="col mobile-header">
          <h4>{{ header }}</h4>
        </div> -->
        <div class="col">
          <h3>{{ header }}</h3>
        </div>
      </div>
      <div class="row mb-x4 d-none">
        <div class="col">
          <div class="zero-tab" @click="toggleJobsTab('current')" :class="{ 'active-tab' : currentJobsTab}">
            Current Jobs
          </div>
        </div>
        <div class="col">
          <div class="zero-tab" @click="toggleJobsTab('past')" :class="{ 'active-tab' : !currentJobsTab}">
            Past Jobs
          </div>
        </div>
      </div>
      <div class="row mb-x4">
        <div class="col">
          <div>
            <h4>Zoho Jobs</h4>
            <div class="italic color-grayscale-3" v-if="cachedon">
              cached on: {{ cachedon }} EST
              <button class="zero-btn zero-btn-tertiary" @click="fetchZoho(true)" v-if="userData.permissions[0] === '1'">refresh cache</button>
            </div>
          </div>
          <div class="zero-notification uhoh mt-x4" v-if="zohoError">
            <div class="zero-notification-icon"></div>
            ZOHO error: {{ zohoError }}
          </div>
        </div>
      </div>
      <div class="row mb-x4" v-if="!zohoError">
        <div class="col-md-6 col-lg-5 col-xl-4 mb-x2" v-for="(event, index) in zohoJobs" :key="index">
          <div class="zero-card">
            <h5 class="d-flex">
              {{ event.Deal_Name }}
              <span class="ml-auto zero-badge align-self-start outline">Z</span>
            </h5>
            <p class="mb-x2">{{ event.Job_Start.slice(0,4) }}</p>
            <router-link :to="'/jobs/z'+ event.id" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-full mb-x2">
              view job
            </router-link>
            <p class="mb-x1 pre-wrap">{{ event.Shoot_Locations }}</p>
            <!-- pulling all jobs cant request field with array -->
            <!-- <CreativesList :creatives="event.creatives" class="mb-x1" zoho/> -->
            <div class="row" v-if="event.Job_Start">
              <div class="col-6 day-item span">
                <div class="date-info">
                  <div class="month">
                    {{ parseDate(event.Job_Start, 'month').slice(0, 3) }}
                  </div>
                  <div class="day">
                    {{ parseDate(event.Job_Start, 'day').padStart(2, '0') }}
                  </div>
                </div>
                <div class="times-info">
                  <div class="fontweight-semibold time-value">{{ parseTimestamp(event.Job_Start, 'time') }}</div>
                  <div class="time-label">Start</div>
                </div>
              </div>
              <!-- job end -->
              <div class="col-6 day-item span">
                <div class="date-info">
                  <div class="month">
                    <!-- {{ parseDate(event.Job_End, 'month').slice(0, 3) }} -->
                      {{ parseDate(event.Job_End, 'month').slice(0, 3) }}
                  </div>
                  <div class="day">
                    {{ parseDate(event.Job_End, 'day').padStart(2, '0') }}
                  </div>
                </div>
                <div class="times-info">
                  <div class="fontweight-semibold time-value">{{ parseTimestamp(event.Job_End, 'time') }}</div>
                  <div class="time-label">End</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-x4">
        <div class="col d-flex justify-content-between">
          <h4>Manually Added Jobs</h4>
          <div class="mobile-hide">
            <router-link to="/jobs/create" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline mobile-hide" v-if="allJobs">
              <i class="fas fa-plus mr-x1"></i>New Job
            </router-link>
          </div>
        </div>
      </div>
      <div class="row mb-x4">
        <div class="col-md-6 col-lg-5 col-xl-4 mb-x2" v-for="(event, index) in tabJobs" :key="index">
          <div class="zero-card">
            <h5 class="mb-x1">{{ event.event_name }}</h5>
            <router-link :to="'/jobs/'+ event.id" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-full mb-x2">
              view job
            </router-link>
            <p class="mb-x1 pre-wrap">{{ event.location }}</p>
            <CreativesList v-if="users.length !== 0" :allUsers="users" :creatives="event.creatives" class="mb-x1"/>
            <div class="row" v-if="event.days.length">
              <!-- job start -->
              <div class="col-6 day-item span">
                <div class="date-info">
                  <div class="month">
                    {{ parseDate(event.days.at(0).date, 'month').slice(0, 3) }}
                  </div>
                  <div class="day">
                    {{ parseDate(event.days.at(0).date, 'day') }}
                  </div>
                </div>
                <div class="times-info">
                  <div class="fontweight-semibold time-value">{{ amPmConvert(event.days.at(0).start_time) }}</div>
                  <div class="time-label">Start</div>
                </div>
              </div>
              <!-- job end -->
              <div class="col-6 day-item span">
                <div class="date-info">
                  <div class="month">
                    {{ parseDate(event.days.at(-1).date, 'month').slice(0, 3) }}
                  </div>
                  <div class="day">
                    {{ parseDate(event.days.at(-1).date, 'day') }}
                  </div>
                </div>
                <div class="times-info">
                  <div class="fontweight-semibold time-value">{{ amPmConvert(event.days.at(0).end_time) }}</div>
                  <div class="time-label">End</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-link to="/jobs/create" class="mobile-add-job zero-btn zero-btn-fab zero-btn-primary bottom-right" v-if="allJobs">
      <i class="fas fa-plus"></i>
    </router-link>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Nav from '@/components/Nav.vue'
import PageLoader from '@/components/PageLoader.vue'
import CreativesList from '@/components/CreativesList.vue'
import shared from '@/shared.js'

Vue.use(VueCookies)
const axios = require('axios')

// endpoints
// const localApiURL = 'http://localhost:8000/'
const apiChoice = process.env.VUE_APP_API_URL

// Using route params
// $route.params.id
// from path: '/user/:id',

export default {
  name: 'home',
  components: {
    Nav,
    PageLoader,
    CreativesList
  },
  data () {
    return {
      isLoading: false,
      userToken: '',
      isLoggedIn: false,
      userData: {
        'id': '',
        'name': '',
        'email': ''
      },
      currentJobs: [],
      pastJobs: [],
      tabJobs: [],
      users: [],
      creatives: [],
      allJobs: false,
      header: 'Jobs',
      currentJobsTab: true,
      isLoadingZoho: false,
      zohoJobs: '',
      zohoWorks: false,
      zohoConsole: '',
      zohoError: '',
      cachedon: ''
    }
  },
  watch: {
    $route (to, from) {
      if (this.$route.path === '/jobs/all') {
        this.allJobs = true
        this.header = 'All Jobs'
        this.getAllJobs()
      } else {
        this.allJobs = false
        this.header = 'My Jobs'
        this.getMyJobs()
      }
    }
  },
  created () {
    if (this.$cookies.isKey('u')) {
      this.isLoggedIn = true
      this.userData = this.$cookies.get('u')
      this.userToken = this.$cookies.get('j') + '.' + this.$cookies.get('w') + '.' + this.$cookies.get('t')
      if (this.$route.path === '/jobs/all') {
        this.allJobs = true
        this.header = 'All Jobs'
        this.getAllJobs()
      } else {
        this.getMyJobs()
      }
      this.fetchZoho()
    }
  },
  methods: {
    getMyJobs () {
      this.isLoading = true
      axios
        .get(apiChoice + 'api/myevents', {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // this.events = response.data
          this.sortJobs(response.data)
          this.getUsers()
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
        })
        .finally(() => {
          // regardless stop the loader
          this.isLoading = false
        })
    },
    getAllJobs () {
      this.isLoading = true
      axios
        .get(apiChoice + 'api/events', {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.sortJobs(response.data)
          this.getUsers()
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
        })
        .finally(() => {
          // regardless stop the loader
          this.isLoading = false
        })
    },
    getUsers () {
      this.isLoading = true
      axios
        .get(apiChoice + 'api/users', {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // transfer the response
          this.users = response.data
        })
        .catch((error) => {
          console.log(error.response.data)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    parseDate (timestamp, dateSegment = 0) {
      return shared.parseDate(timestamp, dateSegment)
    },
    amPmConvert (time) {
      return shared.amPmConvert(time)
    },
    parseTimestamp (timestamp, part) {
      return shared.parseTimestamp(timestamp, part)
    },
    sortJobs (jobs) {
      let today = new Date()
      let dd = String(today.getDate()).padStart(2, '0')
      let mm = String(today.getMonth() + 1).padStart(2, '0')
      let yyyy = today.getFullYear()
      today = yyyy + '-' + mm + '-' + dd

      this.currentJobs = jobs.filter(function (job) {
        if (job.days.length) {
          let lastday = job.days.at(-1)
          return lastday.date >= today
        } else {
          // put jobs with no days (yet) in current
          return true
        }
        // let lastday = job.days.at(-1)
        // return lastday.date >= today
      })
      this.pastJobs = jobs.filter(function (job) {
        if (job.days.length) {
          let lastday = job.days.at(-1)
          return lastday.date < today
        } else {
          return false
        }
        // let lastday = job.days.at(-1)
        // return lastday.date < today
      })
      this.toggleJobsTab('current')
    },
    toggleJobsTab (tab) {
      if (tab === 'current') {
        this.currentJobsTab = true
        this.tabJobs = this.currentJobs
      } else {
        this.currentJobsTab = false
        this.tabJobs = this.pastJobs
      }
    },
    fetchZoho (force = false) {
      this.isLoadingZoho = true
      let forceParam = ''
      if (force) {
        forceParam = '/force'
      }
      axios
        .get(apiChoice + 'api/zohodeals' + forceParam, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // transfer the response
          // this.zohoJobs = response.data.data
          // moved this out to look for cachedon even with errors
          this.cachedon = 'cachedon' in response.data ? this.parseDate(response.data.cachedon.split(' ')[0]) + ' ' + this.amPmConvert(response.data.cachedon.split(' ')[1]) : ''

          if (response.data.hasOwnProperty('data')) {
            this.zohoJobs = response.data.data
            this.zohoWorks = true
          } else {
            console.log(response.data)
            this.zohoWorks = false
            this.zohoError = 'error_description' in response.data ? response.data.error_description : JSON.stringify(response.data)
          }
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          this.isLoadingZoho = false
        })
    },
    flatMapTalent (talents) {
      return Array.isArray(talents) ? talents.flatMap((talent) => [talent.Email]).join(',') : ''
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content .menu-info{
  h2{
    display: block;
  }
}

.desktop-header{
  display: none;
}

.mobile-header{
  display: flex;
  justify-content: center;
}

// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
  .desktop-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .mobile-header {
    display: none;
  }
  .mobile-add-job{
    display: none;
  }
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
